import { render, staticRenderFns } from "./SectionKala4.vue?vue&type=template&id=d4103618&scoped=true&"
import script from "./SectionKala4.vue?vue&type=script&lang=ts&"
export * from "./SectionKala4.vue?vue&type=script&lang=ts&"
import style0 from "./SectionKala4.vue?vue&type=style&index=0&id=d4103618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4103618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VSimpleTable,VTextField,VTextarea})
